import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  TollBarApp: {
    display: 'flex',
    justifyContent: 'space-between',
    height: '100%',
  },
  BoxNotifications: {
    display: 'flex',
    padding: '10px',
    alignItems: 'flex-start',
    gap: '8px',
    borderRadius: '6px',
    background: 'var(--Base-White, #FFF)',
    cursor: 'pointer',
    border: '1px solid var(--Gray-300, #D0D5DD)',
    boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
    boxSizing: 'border-box',
  },
  HeaderStyles: {
    display: 'flex',
    gap: '16px',
    alignItems: 'center',
  },
  BoxSettings: {
    display: 'flex',
    padding: '8px 16px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    borderRadius: '8px',
    border: '1px solid var(--Gray-300, #D0D5DD)',
    background: 'var(--Base-White, #FFF)',
    boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
    boxSizing: 'border-box',
  },
  LocationText: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4px',
  },
  ButtonLocation: {
    width: '20px',
    height: '20px',
    cursor: 'pointer',
  },
}));

export { useStyles };

